// extracted by mini-css-extract-plugin
export default {"wrapper":"UnitsList_wrapper__+ow8D"};